export default __webpack_public_path__ + "static/media/fish0.112bdb53.jpg";